import { useMutation, useQueryClient } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { RelationshipParams } from '../identityTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useUnblockUser = (params: RelationshipParams) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => identityServices.unblockUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_PROFILE, params.userId],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_FAVORITE_USERS],
      })
    },
  })
}
